<template>
  <div class="template-bg">
    <router-view/>
  </div>
</template>

<style lang="sass">

</style>
